__turbopack_context__.v({
  "markdownRoot": "markdown-module__7smWJW__markdownRoot",
});
